import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const PREFIX = 'Company';

export const companyClasses = {
  avatar: `${PREFIX}-avatar`,
};

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  minWidth: 0,
  '&:focus-visible': {
    outline: 'none',
  },
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: 0,
  boxShadow: 'none',
  '&:hover': {
    cursor: 'pointer',
  },
  [`& .${companyClasses.avatar}`]: {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: theme.spacing(1.5),
    color: theme.palette.primary.main,
    fontSize: 16,
    fontWeight: 'bold',
    backgroundColor: theme.palette.background.paper,
  },
}));
